var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar__section sidebar__section--medium-vertical-padding"},[_c('div',{staticClass:"intro-text copy-light"},_vm._l((_vm.text),function(textitem,index){return _c('span',{key:index,domProps:{"innerHTML":_vm._s(textitem.content)}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }